import "./Merchant.css";
import { useState } from "react";
import {
  getAvilableBalanceName,
  getDailytransactions,
} from "../../../config/LiveApi";
import Spinner from "../../Spin/Spinner";
import ProviderModal from "./ProviderModal";

function MerchantTable({ inData, isLoading, startDate, endDate }) {
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [selectedUserName, setSelectedUserName] = useState("");
  const [transactionData, setTransactionData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [loadingBalanceId, setLoadingBalanceId] = useState(null);
  const [liveBalances, setLiveBalances] = useState({});

  // const handleUserClick = async (userId) => {
  //   setSelectedUserId(userId);
  //   try {
  //     const data = await getDailytransactions(userId);
  //     setTransactionData(data);
  //     setShowModal(true);
  //   } catch (error) {
  //     console.error("Error fetching transaction data", error);
  //   }
  // };

  const handleViewBalance = async (name) => {
    try {
      setLoadingBalanceId(name);
      const res = await getAvilableBalanceName(name);
      setLiveBalances((prev) => ({
        ...prev,
        [name]: res,
      }));
      setLoadingBalanceId(null);
    } catch (err) {
      console.error(err);
      setLiveBalances((prev) => ({
        ...prev,
        [name]: "Error",
      }));
      setLoadingBalanceId(null);
    }
  };

  const handleUserClick = async (userId, name) => {
    setSelectedUserId(userId);
    setSelectedUserName(name);
    try {
      const data = await getDailytransactions(userId, startDate, endDate);
      setTransactionData(data);
      setShowModal(true);
    } catch (error) {
      console.error("Error fetching transaction data", error);
    }
  };
  // const handleDateChange = (e) => {
  //   const { name, value } = e.target;
  //   if (name === "startDate") {
  //     setStartDate(value);
  //   } else if (name === "endDate") {
  //     setEndDate(value);
  //   }
  // };

  return (
    <>
      {isLoading ? (
        <Spinner />
      ) : (
        <div
          className="table-main-report"
          style={{
            maxHeight: "650px",
            position: "sticky",
            padding: "0px 10px 0px 10px",
          }}
        >
          <table
            className="table-user-management"
            style={{
              width: "100%",
              borderCollapse: "collapse",
            }}
          >
            <thead
              className="table-user-report"
              style={{
                position: "sticky",
                top: "0",
                zIndex: "999",
              }}
            >
              <tr>
                <td>
                  <p className="user-table-head-report">S.No</p>
                </td>
                <td>
                  <p className="user-table-head-repor">Name</p>
                </td>
                <td>
                  <p className="user-table-head-report">Deposit(INR)</p>
                </td>
                <td>
                  <p className="user-table-head-report">
                    Payin Success Rate(%)
                  </p>
                </td>
                <td>
                  <p className="user-table-head-report">Payin Comm(INR)</p>
                </td>
                <td>
                  <p className="user-table-head-report">total Payin Comm(%)</p>
                </td>
                <td>
                  <p className="user-table-head-report">Rolling Reserve(INR)</p>
                </td>
                <td>
                  <p className="user-table-head-report">Rolling Reserve(%)</p>
                </td>
                <td>
                  <p className="user-table-head-report">Net Payin Comm(INR)</p>
                </td>

                <td>
                  <p className="user-table-head-report">Withdrawal(INR)</p>
                </td>
                <td>
                  <p className="user-table-head-report">
                    Payout Success Rate(%)
                  </p>
                </td>
                <td>
                  <p className="user-table-head-report">Payout Comm(INR)</p>
                </td>
                <td>
                  <p className="user-table-head-report">Total Payout Comm(%)</p>
                </td>
                <td>
                  <p className="user-table-head-report">Payout Net Comm(INR)</p>
                </td>
                <td>
                  <p className="user-table-head-report">Recon Amount(INR)</p>
                </td>
                <td>
                  <p className="user-table-head-report">Total Penalty(INR)</p>
                </td>
                <td>
                  <p className="user-table-head-report">
                    Available Balance(INR)
                  </p>
                </td>
                <td>
                  <p className="user-table-head-report">Wallet Balance(INR)</p>
                </td>
                <td>
                  <p className="user-table-head-report">
                    Net Amount 12AM-5AM(INR)
                  </p>
                </td>
                <td>
                  <p className="user-table-head-report">
                    Net Amount 5AM-7AM(INR)
                  </p>
                </td>
                <td>
                  <p className="user-table-head-report">
                    Net Amount 7AM-1PM(INR)
                  </p>
                </td>
                <td>
                  <p className="user-table-head-report">
                    Net Amount 1PM-7PM(INR)
                  </p>
                </td>
                <td>
                  <p className="user-table-head-report">
                    Net Amount 7PM-12AM(INR)
                  </p>
                </td>
              </tr>
            </thead>
            <tbody>
              {inData &&
                inData.length > 0 &&
                inData.map((item, index) => {
                  return (
                    <>
                      <tr className="table-user-data" style={{}}>
                        <td>
                          <p className="user-table-head">{index + 1}</p>
                        </td>
                        <td>
                          <p
                            className="user-table-name"
                            onClick={() => handleUserClick(item.id, item.name)}
                          >
                            {item.alias || item?.id}
                          </p>
                        </td>
                        <td>
                          <p className="user-table-head">
                            {Number(item.payin).toFixed(2) || "0"}
                          </p>
                        </td>
                        <td>
                          <p className="user-table-head">
                            {Number(item.payinSuccRate).toFixed(2) || "0"}{" "}
                          </p>
                        </td>
                        <td>
                          <p className="user-table-head">
                            {Number(item.payinComm).toFixed(2) || "0"}
                          </p>
                        </td>
                        <td>
                          <p className="user-table-head">
                            {Number(item.payinCommPer).toFixed(2) || "0"}{" "}
                          </p>
                        </td>
                        <td>
                          <p className="user-table-head">
                            {Number(item.rollingReserve).toFixed(2) || "0"}{" "}
                          </p>
                        </td>
                        <td>
                          <p className="user-table-head">
                            {Number(item.rollingResPer).toFixed(2) || "0"}{" "}
                          </p>
                        </td>
                        <td>
                          <p className="user-table-head">
                            {Number(item.payinNetComm).toFixed(2) || "0"}{" "}
                          </p>
                        </td>
                        <td>
                          <p className="user-table-head">
                            {Number(item.payout).toFixed(2) || "0"}
                          </p>
                        </td>
                        <td>
                          <p className="user-table-head">
                            {" "}
                            {Number(item.payoutSuccRate).toFixed(2) || "0"}
                          </p>
                        </td>
                        <td>
                          <p className="user-table-head">
                            {" "}
                            {Number(item.payoutComm).toFixed(2) || "0"}
                          </p>
                        </td>
                        <td>
                          <p className="user-table-head">
                            {Number(item.payoutCommPer).toFixed(2) || "0"}{" "}
                          </p>
                        </td>
                        <td>
                          <p className="user-table-head">
                            {Number(item.payoutNetComm).toFixed(2) || "0"}{" "}
                          </p>
                        </td>
                        <td>
                          <p className="user-table-head">
                            {Number(item.reconAmount).toFixed(2) || "0"}
                          </p>
                        </td>
                        <td>
                          <p className="user-table-head">
                            {Number(item.recontotalPenalty).toFixed(2) || "0"}
                          </p>
                        </td>
                        <td>
                          <p className="user-table-head">
                            {liveBalances[item.id] !== undefined ? (
                              <span>
                                {Number(liveBalances[item.id])?.toFixed(2)}
                              </span>
                            ) : (
                              <button
                                onClick={() => handleViewBalance(item.id)}
                                disabled={loadingBalanceId === item.id}
                                style={{
                                  backgroundColor: "#007bff",
                                  color: "#fff",
                                  border: "none",
                                  padding: "4px 8px",
                                  borderRadius: "4px",
                                  cursor: "pointer",
                                }}
                              >
                                {loadingBalanceId === item.id
                                  ? "Loading..."
                                  : "View"}
                              </button>
                            )}
                          </p>
                        </td>
                        <td>
                          <p className="user-table-head">
                            {Number(item.walletBalance).toFixed(2) || "0"}
                          </p>
                        </td>
                        <td>
                          <p className="user-table-head">
                            {Number(
                              item.payinTimeBreakdown?.time_12am_5am
                            ).toFixed(2) || "0"}
                          </p>
                        </td>
                        <td>
                          <p className="user-table-head">
                            {Number(
                              item.payinTimeBreakdown?.time_5am_7am
                            ).toFixed(2) || "0"}
                          </p>
                        </td>
                        <td>
                          <p className="user-table-head">
                            {Number(
                              item.payinTimeBreakdown?.time_7am_1pm
                            ).toFixed(2) || "0"}
                          </p>
                        </td>
                        <td>
                          <p className="user-table-head">
                            {Number(
                              item.payinTimeBreakdown?.time_1pm_7pm
                            ).toFixed(2) || "0"}
                          </p>
                        </td>
                        <td>
                          <p className="user-table-head">
                            {Number(
                              item.payinTimeBreakdown?.time_7pm_12am
                            ).toFixed(2) || "0"}
                          </p>
                        </td>
                      </tr>
                    </>
                  );
                })}
            </tbody>
          </table>
        </div>
      )}
      {/* <div className="date-filter">
        <label>Start Date:</label>
        <input type="date" name="startDate" value={startDate} onChange={handleDateChange} />
        <label>End Date:</label>
        <input type="date" name="endDate" value={endDate} onChange={handleDateChange} />
      </div> */}
      {showModal && (
        <ProviderModal
          transactionData={transactionData}
          setShowModal={setShowModal}
          startDate={startDate}
          endDate={endDate}
          userName={selectedUserName}
        />
      )}
    </>
  );
}

export default MerchantTable;
